import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const DUMMY = {
  actual_paid_kg_case:   "18.5 kg",
  difference_paid_pct:   "3.2%",
  total_prime_pct:       "72.0%",
  real_kg_case:          "17.9 kg",
  real_kg_case_prime:    "12.9 kg",
};

const boxes = [
  { key: "actual_paid_kg_case",  label: "Actual paid w/ Ripening Waste"              },
  { key: "difference_paid_pct",  label: "Paid % Going Into Processing"    },
  { key: "total_prime_pct",      label: "Total Prime %"                              },
  { key: "real_kg_case",         label: "Real KG/Case"                               },
  { key: "real_kg_case_prime",   label: "Real KG/Case (Prime)"                       },
];

const FruitQualityMetrics = ({ data = DUMMY, isLoading = false }) => (
  <DashboardCard title="Fruit Quality Metrics">
    <div className="fqm-grid">
      {boxes.map((b) => (
        <div key={b.key} className="pp-brokering-box fqm-box">
          <div className="pp-brokering-box-label" style={{ whiteSpace: "pre-line" }}>{b.label}</div>
          <div className="pp-brokering-box-value">
            {isLoading
              ? <span className="db-shimmer" style={{ height: 28, width: 60, display: "block" }} />
              : (data?.[b.key] ?? "—")
            }
          </div>
        </div>
      ))}
    </div>
  </DashboardCard>
);

export default FruitQualityMetrics;
